/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./_src/cfc-interactive-video/amp-plugin-cfc-interactive-video.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./_src/cfc-interactive-video/amp-plugin-cfc-interactive-video.js":
/*!************************************************************************!*\
  !*** ./_src/cfc-interactive-video/amp-plugin-cfc-interactive-video.js ***!
  \************************************************************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _cmds__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./cmds */ "./_src/cfc-interactive-video/cmds/index.js");

/* example:
00:00:10.500 --> 00:00:11.500
cfciv#v1|{cmds:[pause();button(className=yellow,topleft&text=Skip Brain Builder&onclick=seek(timestamp=00:02:52.000));button(className=red,topright&text=Skip All&onclick=seek(timestamp=00:03:17.000))]}
*/

(function () {
  const CUE_POSITION = {
    Before: 'before',
    Inside: 'inside',
    After: 'after'
  };
  const CUE_STATUS = {
    HasNotRun: 'has_not_run',
    Running: 'running',
    HasRun: 'has_run'
  };
  let vttCues = [];
  let player;

  const matchCommand = function (cmd) {
    const obj = {};
    const cmdMatches = cmd.match(/^(\w+)\((.*)\)$/);

    if (cmdMatches && cmdMatches.length) {
      obj.n = cmdMatches[1];

      if (cmdMatches.length > 1 && cmdMatches[2]) {
        obj.p = {};
        cmdMatches[2].split('&').forEach(param => {
          const p = param.split('=');

          if (p.length === 1) {
            // no `=` sign, so treat it as a bool
            obj.p[p[0]] = true;
          } else if (p.length === 2) {
            // it's a normal param, as in `key=val`
            if (p[1].endsWith(')')) {
              // the param is a command
              obj.p[p[0]] = matchCommand(p[1]);
            } else {
              obj.p[p[0]] = p[1];
            }
          } else {
            // the param is a command
            const n = p.shift();
            obj.p[n] = matchCommand(p.join('='));
          }
        });
      }
    }

    return obj;
  };

  const parseCueEvent = function (text) {
    // if it isn't an iteractive video event, move along
    if (!text.startsWith('cfciv')) {
      return {};
    }

    const event = {};
    const eventText = text.split('|');
    const eventMeta = eventText[0].split('#');
    event.v = eventMeta[1];
    const commandMatches = eventText[1].match(/{cmds:\[(.*)\]}/);

    if (commandMatches && commandMatches.length) {
      const commands = commandMatches[1].split(';').map(cmd => matchCommand(cmd));
      event.cmds = commands;
    }

    return event;
  };

  const loadInteractiveTrack = function (vttURL) {
    const xhr = new XMLHttpRequest();

    xhr.onload = function () {
      const data = xhr.responseText;
      parseVTT(data);
    };

    xhr.open('GET', vttURL, true);
    xhr.send();
  };

  const parseVTT = function (vttData) {
    // empty out the cues array before loading new ones:
    clearCues();
    const decoder = WebVTT.StringDecoder();
    const parser = new WebVTT.Parser(window, window.vttjs, decoder);

    parser.oncue = function (cue) {
      const cuePoint = {
        status: CUE_STATUS.HasNotRun,
        position: CUE_POSITION.Before,
        startTime: cue.startTime,
        endTime: cue.endTime,
        event: parseCueEvent(cue.text)
      };
      vttCues.push(cuePoint);
    };

    parser.parse(vttData);
    parser.flush();
  };

  const clearCues = function () {
    vttCues = [];
  };

  const runCue = function (cue) {
    if (cue.status !== CUE_STATUS.Running) {
      cue.status = CUE_STATUS.Running;
      console.info(cue);

      try {
        cue.event.cmds.forEach(cmd => {
          if (cmd.n in _cmds__WEBPACK_IMPORTED_MODULE_0__["default"]) {
            _cmds__WEBPACK_IMPORTED_MODULE_0__["default"][cmd.n](player, cmd.p);
          }
        });
      } catch (err) {
        console.error(err);
      }

      cue.status = CUE_STATUS.HasRun;
    }
  };

  const processCues = function () {
    const currentTime = player.currentTime();
    vttCues.forEach(cue => {
      if (currentTime < cue.startTime) {
        cue.position = CUE_POSITION.Before;
      } else if (currentTime > cue.endTime) {
        cue.position = CUE_POSITION.After;
      } else {
        // we are in the cue!
        // first, see if we *were* before, so now we can run the cue
        if (cue.position === CUE_POSITION.Before) {
          runCue(cue);
        }

        cue.position = CUE_POSITION.Inside;
      }
    });
  };

  const getElemContainer = function () {
    return player.el();
  };

  const addCfcIVElement = function (elem) {
    getElemContainer().appendChild(elem);
  };

  const removeCfcIVElements = function () {
    const elems = getElemContainer().querySelectorAll('.cfciv-elem');

    for (let i = 0; i < elems.length; i++) {
      try {
        getElemContainer().removeChild(elems[i]);
      } catch (err) {// NOP
      }
    }
  };

  if (!window.amp) {
    console.warn('no amp var attached to window');
    return;
  }

  amp.plugin('cfcInteractiveVideo', function (options) {
    player = this;
    player.addCfcIVElement = addCfcIVElement;
    player.removeCfcIVElements = removeCfcIVElements;
    player.addEventListener(amp.eventName.loadeddata, function () {
      loadInteractiveTrack(options.vtt);
    });
    player.addEventListener(amp.eventName.timeupdate, function () {
      processCues();
    });
    player.addEventListener(amp.eventName.play, removeCfcIVElements);
  });
}).call(undefined);

/***/ }),

/***/ "./_src/cfc-interactive-video/cmds/button.js":
/*!***************************************************!*\
  !*** ./_src/cfc-interactive-video/cmds/button.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return button; });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! . */ "./_src/cfc-interactive-video/cmds/index.js");

function button(player, params) {
  const button = document.createElement('button');
  button.textContent = params.text;
  button.className = 'cfciv-elem cfciv-button';
  button.classList.add(...params.className.split(','));

  if (params.onclick) {
    button.addEventListener('click', () => {
      const cmd = params.onclick;

      try {
        if (cmd.n in ___WEBPACK_IMPORTED_MODULE_0__["default"]) {
          ___WEBPACK_IMPORTED_MODULE_0__["default"][cmd.n](player, cmd.p);
        }
      } catch (err) {
        console.error(err);
      }
    });
  }

  const removeElementsHandler = () => {
    player.removeEventListener(amp.eventName.seeking, removeElementsHandler);
    player.removeCfcIVElements();
  };

  player.addEventListener(amp.eventName.seeking, removeElementsHandler);
  player.addCfcIVElement(button);
  setTimeout(() => {
    button.classList.add('show');
  }, 0);
}

/***/ }),

/***/ "./_src/cfc-interactive-video/cmds/index.js":
/*!**************************************************!*\
  !*** ./_src/cfc-interactive-video/cmds/index.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./button */ "./_src/cfc-interactive-video/cmds/button.js");
/* harmony import */ var _pause__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./pause */ "./_src/cfc-interactive-video/cmds/pause.js");
/* harmony import */ var _play__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./play */ "./_src/cfc-interactive-video/cmds/play.js");
/* harmony import */ var _seek__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./seek */ "./_src/cfc-interactive-video/cmds/seek.js");
/* harmony import */ var _popup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./popup */ "./_src/cfc-interactive-video/cmds/popup.js");





/* harmony default export */ __webpack_exports__["default"] = ({
  button: _button__WEBPACK_IMPORTED_MODULE_0__["default"],
  pause: _pause__WEBPACK_IMPORTED_MODULE_1__["default"],
  play: _play__WEBPACK_IMPORTED_MODULE_2__["default"],
  seek: _seek__WEBPACK_IMPORTED_MODULE_3__["default"],
  popup: _popup__WEBPACK_IMPORTED_MODULE_4__["default"]
});

/***/ }),

/***/ "./_src/cfc-interactive-video/cmds/pause.js":
/*!**************************************************!*\
  !*** ./_src/cfc-interactive-video/cmds/pause.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return pause; });
function pause(player
/*, params*/
) {
  player.pause();
}

/***/ }),

/***/ "./_src/cfc-interactive-video/cmds/play.js":
/*!*************************************************!*\
  !*** ./_src/cfc-interactive-video/cmds/play.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return pause; });
function pause(player
/*, params*/
) {
  player.play();
}

/***/ }),

/***/ "./_src/cfc-interactive-video/cmds/popup.js":
/*!**************************************************!*\
  !*** ./_src/cfc-interactive-video/cmds/popup.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return popup; });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! . */ "./_src/cfc-interactive-video/cmds/index.js");

function popup(player, params) {
  const coor = JSON.parse(params.coor);

  if (params.contentID && player.popup) {
    const removeElementsHandler = () => {
      player.removeEventListener(amp.eventName.play, removeElementsHandler);
      player.removeEventListener(amp.eventName.seeking, removeElementsHandler);
      player.popup({
        visible: false
      });
    };

    player.addEventListener(amp.eventName.seeking, removeElementsHandler);
    player.addEventListener(amp.eventName.play, removeElementsHandler);
    player.popup({
      className: params.className.split(','),
      forceReponse: params.forceReponse === "true",
      visible: true,
      contentID: params.contentID,
      top: coor.x,
      left: coor.y,
      height: coor.h,
      width: coor.w,
      ...___WEBPACK_IMPORTED_MODULE_0__["default"]
    });
  }
  /** Error handling */


  const functionExample = `00:00:00.000 --> 00:00:02.000\n
	cfciv#v1|{cmds:[pause();popup(contentID=2U7QtvuRB3aAUrewNiPCZJ&coor={"x":1,"y":2,"w":60,"h":40}&className=test1,test2);]}`;

  if (!params.contentID) {
    console.warn(`AMP player: popup requires a contentful ID, popup example:\n${functionExample}`);
  }

  if (!player.popup) {
    console.warn(`AMP player: popup() requires a popup function to be attached to the player, example:\nthis.yourPlayerInstance.popup = someFunction.bind(this)`);
  }
}

/***/ }),

/***/ "./_src/cfc-interactive-video/cmds/seek.js":
/*!*************************************************!*\
  !*** ./_src/cfc-interactive-video/cmds/seek.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return setPosition; });
const convertTimestampToSeconds = function (ts) {
  const multipliers = [24, 60, 60, 1];
  const timeParts = ts.split(':');
  let factor = 1,
      seconds = 0;

  while (timeParts.length && multipliers.length) {
    factor *= multipliers.pop();
    seconds += parseFloat(timeParts.pop() * factor);
  }

  return seconds;
};

function setPosition(player, params) {
  player.play();
  player.currentTime(convertTimestampToSeconds(params.timestamp));
}

/***/ })

/******/ });
//# sourceMappingURL=current.js.map